import { isNativePlatform } from '@/utils/capacitor';

function isFormControl(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) {
    return true;
  }
  return target.isContentEditable || Boolean(target.closest('[contenteditable="true"]'));
}

export function applyNativeWebGuards(): () => void {
  if (!isNativePlatform()) {
    return () => undefined;
  }

  document.documentElement.classList.add('native-app');

  const onContextMenu = (event: Event) => {
    event.preventDefault();
  };

  const onCopyOrCut = (event: Event) => {
    if (!isFormControl(event.target)) {
      event.preventDefault();
    }
  };

  document.addEventListener('contextmenu', onContextMenu);
  document.addEventListener('copy', onCopyOrCut);
  document.addEventListener('cut', onCopyOrCut);

  return () => {
    document.removeEventListener('contextmenu', onContextMenu);
    document.removeEventListener('copy', onCopyOrCut);
    document.removeEventListener('cut', onCopyOrCut);
  };
}
